import { RootState } from '@debbie/cortex/dist/reducer.js'
import { PlaceholderLoader } from '@debbie/iris/dist/components/index.js'
import CreditorUsers from '@debbie/iris/dist/components/users/CreditorUsers.js'
import React from 'react'
import { useSelector } from 'react-redux'

const Users = (props: {}) => {
  const selectedCreditor = useSelector((s: RootState) => s.selectedCreditor)

  // Authenticate seeds the selection with '' before a creditor is resolved,
  // and that sentinel is stored verbatim — passing it through would send
  // ?creditorId= and fail zod's uuid check with a 422.
  if (selectedCreditor == null || selectedCreditor === '') {
    return <PlaceholderLoader />
  }

  return <CreditorUsers creditorId={selectedCreditor} />
}

export default Users
